import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import Styles from "../../../../../Slices/Mof/Styles.json";
import axios from 'axios'
import ApiSetting from '../../../../../../Settings/ApiSettings.json'
import Cookies from "universal-cookie";
import swal from "sweetalert";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

function CivilStatusCard({getCurrentReportDataAfterUpdate,object,Access,advanceSearch,section_id,stage_transaction_type_id}) {
    const [civilStatusCardRecord,setCivilStatusCardRecord]=useState(object?.civil_status_card_record)
    const [civilStatusCardPage,setCivilStatusCardPage]=useState(object?.civil_status_card_page)
    const [civilStatusCardNumber,setCivilStatusCardNumber]=useState(object?.civil_status_card_number)
    const [loading,setLoading]=useState(false)
    const checkAccessPrivileges =()=>{
        let check=true;
        Access?.map((data)=>{
            if(data==1){
                check=true;
            }else if(data==2||data==3||data==4){
                check=false
            }
        })
        return check;
    }
    const checkAccessPrivilegesCanEdit=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==3){
                check=true;
             }
        })
        return check;
    }
    const checkAccessPrivilegesCanAdd=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==2){
                check=true;
             }
        })
        return check;
    }

    const updateData=async()=>{
        let data=null;
        setLoading(true);
        try{
            data=await axios({
               method: 'put',
               url:ApiSetting.apiUrl+'/income_tax_report/'+object?.id,
               data:{
                section_name:'2',
                civil_status_card_record:civilStatusCardRecord,
                civil_status_card_page:civilStatusCardPage,
                civil_status_card_number:civilStatusCardNumber,
                user_id:cookies.get('user_id'),
                role_id:cookies.get('role_id')+1,
                section_id:section_id,
                stage_transaction_type_id:stage_transaction_type_id
               },
               headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-localization": language,
               }
            })
            if(data){
                if(data?.data?.status==200){
                    swal("تم التحديث!", `${data?.data?.message}`, "success");
                    setCivilStatusCardRecord(data?.data?.data?.civil_status_card_record);
                    setCivilStatusCardPage(data?.data?.data?.civil_status_card_page);
                    setCivilStatusCardNumber(data?.data?.data?.civil_status_card_number);
                    advanceSearch()            
                    getCurrentReportDataAfterUpdate()

                }else{
                    console.log(data?.data?.message);
                    swal("فشل التحديث!", `${data?.data?.message}`, "warning");

                }
            }
        setLoading(false);

        }catch(err){
            swal("فشل التحديث!", `${err?.message}`, "error");
            setLoading(false);

        }
        
    }

    return (
        <>
            {/*###==> civil status card here ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                بطاقة الاحوال المدنية
            </h4>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",

                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="سجل"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={civilStatusCardRecord}
                            onChange={(e) => {
                                setCivilStatusCardRecord(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.civilStatusCardRecord) {
                            return err.civilStatusCardRecord;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="صفحه"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={civilStatusCardPage}
                            onChange={(e) => {
                                setCivilStatusCardPage(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.civilStatusCardPage) {
                            return err.civilStatusCardPage;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="رقم"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={civilStatusCardNumber}
                            onChange={(e) => {
                                setCivilStatusCardNumber(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.civilStatusCardNumber) {
                            return err.civilStatusCardNumber;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>
            </div>
            {
              checkAccessPrivilegesCanAdd()||checkAccessPrivilegesCanEdit()?
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                    <Button variant="contained" style={{backgroundColor:"#5f7b8a",paddingLeft:30,paddingRight:30}}
                    onClick={()=>{
                        updateData();
                    }}
                    >
                        {!loading ? (
                        "تحديث"
                    ) : (
                        <div class="spinner-border " role="status">
                        <span class="visually-hidden">Loading...</span>
                        </div>
                    )}
                    </Button>
                </div>:null
            }
        </>
    )
}

export default CivilStatusCard